export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SvgImage.vue?vue&type=template&id=6aa213f2&"


//////////////////
// WEBPACK FOOTER
// ./src/components/SvgImage.vue?vue&type=template&id=6aa213f2&
// module id = 85
// module chunks = 12